export default "__VITE_ASSET__CxCtLnQn__"